import React from 'react';
import { Link } from 'gatsby';
import { usePagination, DOTS } from '../utils/usePagination';
import classnames from 'classnames';
import '../../../sass/_pagination.scss';
import IconArrowRight from "../../../icons/icon-pagination-arrow-right.svg";
import IconArrowLeft from "../../../icons/icon-pagination-arrow-left.svg";

const TagBlogPagination = props => {
  const {
    totalPageCount,
    siblingCount = 1,
    currentPage,
    className,
    nextPageUrl,
    previousPageUrl,
    tag
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalPageCount,
    siblingCount,
  });

  if (paginationRange.length <= 1) {
    return null;
  }

  let lastPage = paginationRange[paginationRange.length - 1];

  const goToPage = (number) => {

      if(number === 1){
        return(`/blog/tag/${tag}/`)
      }
      else{
        return(`/blog/tag/${tag}/${number}/`)
      }
  }
  
  return (
    <ul
      className={classnames('pagination-container', { [className]: className })}
    >
      <Link
        to={`/${previousPageUrl}`}
        className={classnames('pagination-item', {
          disabled: currentPage === 1
        })}
        
        //onClick={onPrevious}
      >
        <div className="arrow left" >
          <IconArrowLeft/>
        </div>
      </Link>
      {paginationRange.map( (pageNumber,index) => {
        if (pageNumber === DOTS) {
          return <li className="pagination-item dots" key={index}>&#8230;</li>;
        }

        return (
          <Link
            className={classnames('pagination-item', {
              selected: pageNumber === currentPage
            })}
            //onClick={() => onPageChange(pageNumber)}
            //onClick={goToPage(pageNumber)}
            to={goToPage(pageNumber)}
            key={index}
          >
            {pageNumber}
          </Link>
        );
      })}
      <Link
        to={`/${nextPageUrl}`}
        className={classnames('pagination-item', {
          disabled: currentPage === lastPage
        })}
        //onClick={onNext}
        
      >
        <div className="arrow right" >
          <IconArrowRight/>
        </div>
      </Link>
    </ul>
  );
};

export default TagBlogPagination;